import { render, staticRenderFns } from "./OrderCollectBoxes.vue?vue&type=template&id=28130696&"
import script from "./OrderCollectBoxes.vue?vue&type=script&lang=js&"
export * from "./OrderCollectBoxes.vue?vue&type=script&lang=js&"
import style0 from "./OrderCollectBoxes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports